import { render, staticRenderFns } from "./AddConnection.vue?vue&type=template&id=3dc8bcd6&"
import script from "./AddConnection.vue?vue&type=script&lang=js&"
export * from "./AddConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports